import type { SimEvent } from '../sim/events';
import { WEAPON_BY_ID, weaponDisplayName } from '../sim/weapons/defs';

type Knockout = Extract<SimEvent, { type: 'kill' }>;
export function knockoutDetail(event: Knockout): string {
  if (event.cause === 'void') return 'Ring out';
  if (event.cause === 'burn') return 'Burn damage';
  if (event.cause === 'sudden-death') return 'Sudden death';
  if (event.method === 'snake') return 'Snake bite';
  if (event.method === 'hazard') return 'Arena hazard';
  const def = event.weaponId ? WEAPON_BY_ID.get(event.weaponId)?.def : undefined;
  const weapon = def ? weaponDisplayName(def) : event.method === 'punch' ? 'Punch' : 'Knockout';
  return `${event.method === 'thrown' ? 'Thrown ' : ''}${weapon}${event.zone === 'head' ? ' · Headshot' : ''}`;
}

/** A small bounded history, separate from pickup/promotion messages. */
export function createCombatFeed(root: HTMLElement) {
  const entries: { node: HTMLElement; until: number }[] = [];
  return {
    clear() {
      entries.length = 0;
      root.replaceChildren();
    },
    expire(now: number) {
      for (let i = entries.length - 1; i >= 0; i--)
        if (entries[i]!.until <= now) {
          entries[i]!.node.remove();
          entries.splice(i, 1);
        }
    },
    milestone(name: string, streak: number, color: string, now: number) {
      const row = document.createElement('div');
      row.className = 'combat-feed-row combat-feed-streak';
      row.style.setProperty('--fighter-color', color);
      const label = document.createElement('strong');
      label.textContent = `${name} · ${streak} KO streak`;
      row.append(label);
      root.prepend(row);
      entries.unshift({ node: row, until: now + 4500 });
      if (entries.length > 3) entries.pop()!.node.remove();
    },
    add(
      event: Knockout,
      target: string,
      source: string | undefined,
      color: string,
      personal: boolean,
      now: number,
    ) {
      const row = document.createElement('div');
      row.className = 'combat-feed-row';
      row.dataset.personal = String(personal);
      row.style.setProperty('--fighter-color', color);
      const names = document.createElement('strong');
      names.textContent =
        event.source === event.target
          ? `${target} · Self KO`
          : source
            ? `${source} → ${target}`
            : target;
      const detail = document.createElement('span');
      detail.textContent = knockoutDetail(event);
      row.append(names, detail);
      root.prepend(row);
      entries.unshift({ node: row, until: now + (personal ? 8000 : 5500) });
      if (entries.length > 3) entries.pop()!.node.remove();
    },
  };
}
